import { IconCheckCircleFilled } from '@iwoca/icons';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { FormattedMessage } from 'react-intl';

import styles from './TruelayerConfirmation.module.css';
import { MoneyWithDecimals } from '../../ui/moneyWithDecimals';

export const PaymentSuccessful = ({
    paymentReference,
    amount
}: {
    paymentReference: string;
    amount: number;
}) => (
    <div className={styles.confirmationContainer}>
        <IconCheckCircleFilled className={styles.successIcon} />
        <div className={styles.primaryContent} data-testid="amount-container">
            Thanks, we’ve received your payment of
            <div className={styles.amount}>
                <MoneyWithDecimals value={amount} />
            </div>
            Your outstanding balance may take a moment to update
        </div>
        <div
            className={styles.secondaryContent}
            data-testid="reference-container"
        >
            You’ll receive an email confirmation shortly <br />
            Payment reference: {paymentReference}
        </div>

        <NEW_IwLinkButton
            to={{
                pathname: '/'
            }}
            className="mt-l box-border h-[52px] px-l"
        >
            <FormattedMessage
                id="_.navigation.return_to_dashboard"
                defaultMessage="Return to dashboard"
            />
        </NEW_IwLinkButton>
    </div>
);
